
        var result = require("!!../../../../../node_modules/css-loader/index.js!./error.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/pages/auth/error/error.component.css
// module id = 352
// module chunks = 3